import React, { useEffect, useState } from 'react'
import Layout from '../../components/common/pageLayout'
import { toast } from 'react-toastify'
import SubmittedExpensesList from '../../components/expense/SubmittedExpensesList' // New component for displaying expenses
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min'
import { v3_delete_expense_entry, v3_submitted_expenses } from '../../actions/v3/expenses' // New API for fetching submitted expenses
import constant from '../../constant'
import moment from "moment";
import ExportColumnModal from '../../components/common/ExportColumnModal';
import RecordListFilters from '../../components/common/RecordListFilters';
import { exportRowsToExcel, getLoggedInUserRoleId, replacePageState } from '../../utils';

const List = (props) => {

    const location = useLocation();
    const { page } = location.state || {}; // Get page number from location state
    const [data, setData] = useState(null); // Store the fetched expense data
    const [currentPage, setCurrentPage] = useState(page ? page : 1); // Current page for pagination
    const [limit] = useState(10); // Number of records per page
    const [isExporting, setIsExporting] = useState(false);
    const [filters, setFilters] = useState({ fromDate: '', toDate: '', name: '', subject: '' });
    const isAdmin = Number(getLoggedInUserRoleId()) === 1;

    const formatLastUpdated = (item) => {
        const timestamp = item?.MODIFIED_ON || item?.CREATED_ON;
        if (!timestamp) return '-';
        const parsed = moment(timestamp);
        return parsed.isValid() ? parsed.format("DD MMM YYYY, hh:mm A") : '-';
    };

    const expenseExportColumns = [
        { key: 'serialNo', label: 'S.No', value: (item, index) => index + 1 },
        { key: 'employeeName', label: 'Employee Name', value: (item) => item.FULL_NAME },
        { key: 'location', label: 'Location', value: (item) => item.LOCATION_NAME },
        { key: 'expenseType', label: 'Expense Type', value: (item) => item.EXPENSE_TYPE_NAME },
        { key: 'fromDate', label: 'From Date', value: (item) => item.EXPENSE_FROM_DATE || item.EXPENSE_DATE || '' },
        { key: 'toDate', label: 'To Date', value: (item) => item.EXPENSE_TO_DATE || item.EXPENSE_DATE || '' },
        { key: 'totalExpenseUsd', label: 'Total Expense (USD)', value: (item) => item.TOTAL_USD_EQUIV },
        { key: 'totalItems', label: 'Total Items', value: (item) => item.expense_items?.length || 0 },
        { key: 'status', label: 'Status', value: (item) => item.STATUS },
        { key: 'lastUpdated', label: 'Last Updated', value: formatLastUpdated },
    ];

    useEffect(() => {
        // Fetch submitted expenses using v3_submitted_expenses API
        v3_submitted_expenses(currentPage, limit, filters).then((res) => {
            if (res.status) {
                setData(res.result); // Set the fetched data
                replacePageState(props.history, constant.Authedcomponent.expenseList.url, {
                    page: currentPage // Store current page in history for navigation
                });
            }
            else {
                toast.error(res.error); // Show error message if API call fails
            }
        })
    }, [currentPage, limit, filters]); // Re-fetch when currentPage or limit changes
    const updateFilters = (nextFilters) => {
        setCurrentPage(1);
        setFilters(nextFilters);
    };
    const exportAllExpenses = async (selectedColumns = expenseExportColumns) => {
        try {
            setIsExporting(true);
            toast.info("Preparing Excel export, please wait...");

            let allExpenses = [];
            let pageNum = 1;
            const exportLimit = 100; // Fetch 100 per page for faster export

            while (true) {
                const res = await v3_submitted_expenses(pageNum, exportLimit, filters);
                if (!res.status) break;

                const currentExpenses = res.result?.expenses || [];
                allExpenses = [...allExpenses, ...currentExpenses];

                // If we fetched fewer than the limit, it means we’re done
                if (currentExpenses.length < exportLimit) break;

                pageNum++;
            }

            if (allExpenses.length === 0) {
                toast.warn("No data found to export");
                setIsExporting(false);
                return;
            }

            exportRowsToExcel({
                rows: allExpenses,
                columns: selectedColumns,
                sheetName: "All Expenses",
                fileName: `Expense_Report_${moment().format("YYYYMMDD_HHmmss")}.xlsx`,
            });

            toast.success("Excel exported successfully!");
        } catch (error) {
            console.error(error);
            toast.error("Error while exporting data");
        } finally {
            setIsExporting(false);
        }
    };
    const deleteExpense = async (expenseId) => {
        if (!window.confirm('Delete this expense entry? This cannot be undone.')) return;
        const res = await v3_delete_expense_entry(expenseId);
        if (res.status) {
            toast.success(res.result?.message || 'Expense entry deleted.');
            setCurrentPage(1);
            setFilters({ ...filters });
        } else toast.error(res.error || 'Unable to delete expense entry.');
    };
    return (
        <Layout title={'Submitted Expenses'}>
            {/* Render SubmittedExpensesList if data is available */}
            <RecordListFilters value={filters} onChange={updateFilters} showName={false} />
            <div className="d-flex justify-content-end mb-3">
                <button
                    className="btn btn-sm btn-primary me-2"
                    style={{
                        backgroundImage:
                            "linear-gradient(90deg, rgb(104, 149, 180), rgb(38, 85, 120))"
                    }}
                    type="button"
                    data-bs-toggle="modal"
                    data-bs-target="#submitted-expense-export-columns-modal"
                    disabled={isExporting}
                >
                    {isExporting ? (
                        <>
                            <i className="bx bx-loader-alt bx-spin"></i> Exporting...
                        </>
                    ) : (
                        <>
                            <i className="mdi mdi-file-excel-outline label-icon"></i> Export All to Excel
                        </>
                    )}
                </button>
            </div>
            {data && <SubmittedExpensesList
                limit={limit}
                data={data}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                isAdmin={isAdmin}
                onDelete={deleteExpense}
            />}
            <ExportColumnModal
                modalId="submitted-expense-export-columns-modal"
                title="Select Expense Columns"
                columns={expenseExportColumns}
                onExport={exportAllExpenses}
                isExporting={isExporting}
            />
        </Layout>
    );
}

export default List;
